module.exports = __webpack_public_path__ + "assets/images/artypiques-ca42dc1916094eb32bf29807ace45656.png";